<template>
  <CSelect
    class="w-auto"
    :consistent-menu-width="false"
    hide-option-icon
    :options="lineHeightOptions"
    :renderLabel="renderLabel"
    :showCheckmark="false"
    :value="getLineHeightValue"
    @update:value="setLineHeight($event)"
  />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { computed, type VNode } from 'vue'

import type { Option } from '@lib/components/CRichTextEditor/components/CEditorMenu.vue'
import type { Editor } from '@tiptap/vue-3'
import CSelect from '@lib/components/CSelect/CSelect.vue'

enum LineHeightValues {
  COMPACT = '100%',
  DEFAULT = '160%',
  RELAXED = '200%',
}

interface Props {
  editor: Editor
  renderLabel: (option: Option) => VNode
}

const props = defineProps<Props>()
const { t } = useI18n()

const lineHeightOptions: Option[] = [
  {
    icon: 'line-height',
    label: t('canvasUI.CRichTextEditor.lineHeight.compact'),
    value: LineHeightValues.COMPACT,
  },
  {
    icon: 'line-height',
    label: t('canvasUI.CRichTextEditor.lineHeight.default'),
    value: LineHeightValues.DEFAULT,
  },
  {
    icon: 'line-height',
    label: t('canvasUI.CRichTextEditor.lineHeight.relaxed'),
    value: LineHeightValues.RELAXED,
  },
]

const getLineHeightValue = computed(() => {
  const lineHeight = props.editor.getAttributes('textStyle').lineHeight
  return lineHeight || LineHeightValues.DEFAULT
})

const setLineHeight = (value: LineHeightValues) => {
  if (value === LineHeightValues.DEFAULT) {
    props.editor.chain().focus().unsetLineHeight().run()
  } else {
    props.editor.chain().focus().setLineHeight(value).run()
  }
}
</script>
